import { createBrowserRouter } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import Books from "../pages/Books";

// Auth
import LoginPage from "../pages/auth/LoginPage";
import RegisterPage from "../pages/auth/RegisterPage";
import ForgotPasswordPage from "../pages/auth/ForgotPasswordPage";
import ResetPasswordPage from "../pages/auth/ResetPasswordPage";
import DeposerLivrePage from "../pages/DeposerLivrePage";
import PrivateRoute from "./PrivateRoute";
import Contact from "../pages/Contact";
import HomePage from "../pages/Home";
import LegalNoticePage from "../pages/LegalNoticePage";
import VerifyCodePage from "../pages/VerifyCodePage";
import PublicRoute from "./PublicRoute";
import ConnectedOnlyRoute from "./ConnectedOnlyRoute";
import AdminPage from "../pages/auth/Admin";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <MainLayout />,
    children: [
      { index: true, element: <HomePage /> },
      {
        path: "books",
        element: (
          <PrivateRoute>
            <Books />
          </PrivateRoute>
        ),
      },
      { path: "contact", element: <Contact /> },

      // Auth
      {
        path: "login",
        element: (
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        ),
      },
      { path: "register", element: <RegisterPage /> },
      { path: "forgot-password", element: <ForgotPasswordPage /> },
      { path: "reset-password", element: <ResetPasswordPage /> },
      { path: "admin", element: <AdminPage /> },
      {
        path: "verify-code",
        element: (
          <ConnectedOnlyRoute>
            <VerifyCodePage />
          </ConnectedOnlyRoute>
        ),
      },

      {
        path: "deposer",
        element: (
          <PrivateRoute>
            <DeposerLivrePage />
          </PrivateRoute>
        ),
      },
      { path: "/legal-notice", element: <LegalNoticePage /> },
    ],
  },
]);
